import { classes } from "lib/actions/util";
import { MouseEvent, PropsWithChildren, useEffect } from "react";
import styled from "styled-components";
import { useTabsTab } from "./useTabs";

const Tab = (
  p: PropsWithChildren<{
    className?: string;
    disabled?: boolean;
    initial?: boolean;
    onActivate?: () => boolean | void;
  }>,
) => {
  const { isActive, activate } = useTabsTab();

  const onClick = (e: MouseEvent) => {
    if (p.disabled || isActive) return;

    if (p.onActivate?.() === false) return;

    activate();
  };

  useEffect(() => {
    if (p.initial) activate();
  }, []);

  return (
    <div
      className={classes(
        "select-none",
        isActive && "tab-active",
        p.disabled && "tab-disabled",
        p.className,
      )}
      onClick={onClick}
    >
      {p.children}
    </div>
  );
};

export default styled(Tab)``;
